export const SET_CURRENT_STOP = "SET_CURRENT_STOP";

export const stopChangeTrigger = {
  DESTINATION_LIST: "destination_list",
  MAP_CLICK: "map_click",
  QUERY_PARAM: "query_param",
} as const;

type StopChangeTriggerType = typeof stopChangeTrigger[keyof typeof stopChangeTrigger];

interface ActionTypes {
  SET_CURRENT_STOP: number;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: {
    currentStop: number;
    trigger?: StopChangeTriggerType;
  };
}

export function setCurrentStop(
  currentStop: number,
  trigger?: StopChangeTriggerType
): CurrentStopActionTypes {
  return {
    type: SET_CURRENT_STOP,
    payload: { currentStop, trigger },
  };
}

export type CurrentStopActionTypes = MessageAction;
